<template>
	<div class="mb-6">
		<ul class="flex items-center text-xl font-light">
			<li v-if="showHome" class="breadcrumb">
				<a href="/">
					<inline-svg name="home"></inline-svg>
					Home
				</a>
			</li>
			<li v-for="(crumb, crumbIndex) in crumbs" :key="crumbIndex" class="breadcrumb">
				<div v-if="crumb.url">
					<a :href="crumb.url">
						<inline-svg v-if="crumb.icon" :name="crumb.icon"></inline-svg>
						{{ crumb.text }}
					</a>
				</div>
				<div v-else class="flex items-center">
					<inline-svg v-if="crumb.icon" :name="crumb.icon"></inline-svg>
					{{ crumb.text }}
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			crumbs: {
				type: Array,
				required: true
			},

			showHome: {
				type: Boolean,
				default: true
			}
		}
	}
</script>